import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";

import styles from "./SideBar.module.scss";

import "assets/icons/style.css";

const SideBar = ({ options, isOpen, toggle }) => {
  let location = useLocation();

  const isActive = (path) => {
    if (location.pathname.split("/")[2] == path) {
      return styles.active_menu;
    } else {
      return styles.inactive_menu;
    }
  };

  return (
    <div
      className={styles.sideBar}
      style={{
        width: isOpen ? "200px" : "74px",
      }}
    >
      <ul>
        {options.map((list, index) => {
          return (
            <Link to={list.to} key={index} onClick={() => toggle()}>
              <li className={isActive(list.routeName)} id={`tooltip-${index}`}>
                <i className={list.icon}></i>
                <span>{list.label}</span>
              </li>
              {!isOpen && (
                <UncontrolledTooltip
                  placement="right"
                  target={isOpen ? null : `tooltip-${index}`}
                  hideArrow={true}
                >
                  {list.label}
                </UncontrolledTooltip>
              )}
            </Link>
          );
        })}
      </ul>
    </div>
  );
};

export default SideBar;
